<template>
  <v-form @submit.prevent="submitLogin" class="d-flex justify-center flex-column mx-auto" ref="loginForm" :class="$vuetify.breakpoint.lgAndUp ? 'mx-auto' : 'w-100'">
    <v-card-text class="d-flex flex-column align-center px-0 mx-0" :class="$vuetify.breakpoint.lgAndUp">
      <app-text-field :rules="$rules.mobileNumberRules" customClass="mobile-text-field" :label="$t('label.mobileNumber')" v-model="loginObj.mobileNumber">
        <template v-slot:text-field-prepend-inner>
          <v-menu tile bottom offset-y left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text tile v-bind="attrs" v-on="on" class="pa-0 primary--text my-auto">
                {{ selectedCountry.phone_code }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list tile class="pa-0">
              <v-list-item v-for="country in countryList" :key="country.id" active-class="primary--text text--lighten-1" @click="selectedCountry = country">
                <v-list-item-title>{{ country.phone_code }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </app-text-field>

      <app-text-field :rules="$rules.requiredRules" type="password" :label="$t('label.password')" v-model="loginObj.password"></app-text-field>

      <v-expand-transition>
        <p v-show="loginError" class="error--text">
          {{ loginError }}
        </p>
      </v-expand-transition>
    </v-card-text>

    <button type="button" @click="$root.$app.openForgotPasswordDialog">{{ $t('label.forgotPassword') }}?</button>

    <v-card-actions class="d-flex flex-column align-stretch px-4">
      <app-button class="green-gradient-right override-disabled-styles" type="submit" :disabled="loginButtonIsDisabled" :loading="loading" invert gradient :label="$t('label.login')" />
    </v-card-actions>

    <div>
      <p class="dark-grey--text text-center">
        {{ `${$t('label.dontHaveAccount')}?` }}
        <button class="text-decoration-underline text-capitalize" @click="$root.$app.openSignUpDialog" type="button">
          {{ `${$t('label.signUp')}!` }}
        </button>
      </p>
    </div>
  </v-form>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data: () => ({
    loading: false,
    loginObj: {
      mobileNumber: '',
      password: ''
    },
    selectedCountry: {},

    loginError: ''
  }),

  computed: {
    ...mapState('common', ['countryList']),
    loginButtonIsDisabled() {
      return !this.loginObj.mobileNumber || !this.loginObj.password
    }
  },

  async mounted() {
    await this.getCountryList()
    this.selectedCountry = this.countryList[0]
  },

  methods: {
    ...mapActions('common', ['getCountryList']),
    ...mapActions('auth', ['login']),

    close() {
      this.$nextTick(() => {
        const defaultForm = {
          mobileNumber: '',
          password: ''
        }
        this.loginObj = { ...defaultForm }
      })
      this.$root.$app.closeLoginDialog()
    },

    async submitLogin() {
      if (!this.$refs.loginForm.validate()) return
      this.loading = true
      this.loginError = ''
      const loginParams = {
        countryId: this.selectedCountry.id,
        mobileNumber: this.loginObj.mobileNumber,
        password: this.loginObj.password
      }
      await this.login(loginParams)
        .then(() => {
          this.close()
        })
        .catch((errorMessage) => {
          this.loginError = errorMessage
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.gray-line {
  height: 1px;
}
</style>
